import { Colors } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';

let currentTitleSelected = null;
export default class ButtonOption extends Lightning.Component {
  static _template() {
    return {
      w: 100,
      h: 60,
      flex: { direction: 'row', justifyContent: 'center', alignItems: 'center' },
      Title: {
        y: 3,
        color: Colors('#d6d6d6').get(),
      },
    };
  }

  set data(val) {
    this._data = val;
  }

  set index(val) {
    this._index = val;
  }

  get _Title() {
    return this.tag('Title');
  }

  _active() {
    currentTitleSelected = null;
  }

  _focus() {
    this._Title.patch({
      color: Colors('#02AC25').get(),
    });
  }

  _unfocus() {
    this._Title.patch({
      color: Colors('#d6d6d6').get(),
    });
  }

  _handleHover() {
    this.fireAncestors('$setFocusKeyOption', { row: this._rowIndex, index: this._index });
    this.fireAncestors('$setState', 'KeyboardOptions');
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _enable() {
    this._Title.patch({
      text: { text: this._data.title },
    });
  }

  _handleEnter() {
    if (this._data.title === currentTitleSelected) {
      return;
    } else {
      this.fireAncestors('$changeKeyboard', this._data.title);
      currentTitleSelected = this._data.title;
    }
  }
}
